<template>
  <div class="legend">
    <div class="legend-section">
      <div class="top">
        <span class="node is-1" />
        <span class="label">Chanson</span>
      </div>
      <span class="pr-5">Une <b>bulle</b> représente une chanson</span>
    </div>
    <div class="legend-section">
      <div class="top">
        <div class="size">
          <span class="node is-3" />
          <span class="node is-2" />
          <span class="node" />
        </div>
        <span class="label">Taille</span>
      </div>
      <span class="pr-10">La <b>taille</b> indique le nombre d'influences (adaptations + reprises) de la chanson</span>
    </div>
    <div class="legend-section">
      <div class="top">
        <span class="node is-dotted" />
        <span class="label">Arbre d'adaptations</span>
      </div>
      <span class="pr-10">Les <b>pointillés</b> indiquent que la chanson est liée à d'autres adaptations n'impliquant pas {{ artist.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		artist: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.legend {
    display: flex;
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 1.2;

    .legend-section {
      margin-right: 20px;
      color: #333;
    }

    .legend-section {
      & > * {
        vertical-align: middle;
      } 
    }

    .top {
      display: flex;
      vertical-align: middle;
      height: 20px;
      align-items: center;

      .label {
        padding-left: 6px;
        font-size: 14px;
        color: #333;
      }
    }

    .node {
      display: inline-block;
      vertical-align: middle;
      height: 7px;
      width: 7px;
      border-radius: 100px;
      background-color: #a0aec0;
      border: 1px #535a63 solid;
      &.is-1 {
        height: 12px;
        width: 12px;
      }
      &.is-2 {
        height: 12px;
        width: 12px;
      }
      &.is-3 {
        height: 20px;
        width: 20px;
      }
      &.is-dotted {
        height: 12px;
        width: 12px;
        position: relative;
        &:before {
          content: '';
          display: block;
          position: absolute;
          top: -3px;
          left: -3px;
          height: 16px;
          width: 16px;
          border: 1px dashed #555;
          border-radius: 20px;
        }
      }
    }
}
</style>
